const textsMapper = {
    pages: {
        homePage: {
            title: {
                heIL: `ברוכים הבאים \n ל`,
                enUS: 'Welcome to ',
                arIL: 'مرحبًا بكم في',
                nlNL: 'Welkom bij'
            },
            description: 'הידעתם? מוזיאון ישראל, ירושלים נוסד בשנת 1965 והוא ממוסדות התרבות הגדולים במדינת ישראל ונמנה עם המוזיאונים לאמנות וארכיאולוגיה המובילים בעולם. באוספי המוזיאון, הכוללים כחצי מיליון פריטים, מגוון עצום של חפצים, מכל קשת תרבויות העולם ומכל התקופות.בחרו את התערוכה בה אתם מבקרים, חברו אזניות לטלפון שלכם וקבלו הדרכה אישית',
            button: 'התחל/י סיור'
        },
        exhibitionsPage: {
            title: {
                heIL: "כל התערוכות",
                enUS: 'Exhibitions',
                nlNL: 'Tentoonstellingen'
            },
            subtitle: ''
        },
        aboutPage: {
            title: {
                heIL: 'אודות התערוכה',
                enUS: 'About the Exhibition',
                nlNL: 'Over de tentoonstelling'
            },
            data: '12 באפריל 2024',
            collectors: 'אוצרים: אמיתי מנדלסון, טניה סירקוביץ, אחיעד עובדיה, פרחיה איילעוזרות לאוצרים: אלינור זילברמן, לולה וילנקין',
            designer: 'מעצבת: שירלי יהלומי',
            location: 'הביתן על-שם אילה זקס אברמוב והבניין לאמנות מודרנית ועכשווית על-שם נתן קמינגס',
            button: 'התחל/י סיור'
        },
        errorPage: {
            message: {
                heIL: 'מצטערים, נתקלנו בשגיאה...',
                enUS: 'We are sorry, there was an error...',
                nlNL: 'Sorry, er is een fout opgetreden...'
            }
        },
        stationPage: {
            error: {
                he: 'מצטערים, המידע שביקשת אינו קיים',
                en: 'We are sorry, this resource does not exists',
                nlNL: 'Sorry, deze bron bestaat niet'
            }
        },
        about: {
            title: {
                heIL: 'אודות',
                enUS: 'About',
                arIL: 'حول',
                nlNL: 'Over'
            },
            content: {
                default: {
                    heIL: "ההדרכה הדיגיטלית באפליקציה זו נוצרה בשיתוף פעולה בין חברת Xsite ו Mensch Edutainment. <br><br> החברות מפיקות חווית דיגיטליות לאתרי תיירות ומוזיאונים ומאפשרת חווית מתקדמות כגון משחקים, הדרכות והפעלות במציאות רבודה, במגוון שפות ובהתאמה לקהלים שונים", 
                    enUS: "This application was created in collaboration between Xsite and Mensch Edutainment. <br> <br> The companies produce digital experiences for tourist sites and museums, enabling advanced experiences such as games, guides, and activities in augmented reality, in various languages, and tailored to different audiences.",
                    arIL: "تم إنشاء الإرشاد الرقمي بالديجيتال في هذا التطبيق بالتعاون بين شركة Xsite وMensch Edutainment. <br><br> تقوم الشركات بإنتاج تجربة رقمية للمواقع السياحية والمتاحف وتمكّن تجربة متقدمة مثل الألعاب وإرشاد البرامج التعليمية والفعاليات في الواقع المكون من طبقات من المعلومات، بلغات متنوعة وبما يتوافق مع مختلف الجماهير",
                    nlNL: "Deze toepassing is gemaakt in samenwerking tussen Xsite en Mensch Edutainment. <br> <br> De bedrijven produceren digitale ervaringen voor toeristische sites en musea, waardoor geavanceerde ervaringen zoals spellen, gidsen en activiteiten in augmented reality mogelijk worden, in verschillende talen en aangepast aan verschillende publieken"
                },
                walking: {
                    heIL: "טקסט אודות עבור walking tour - להשלמה", 
                    enUS: `<div style="font-size: 16px; line-height: 1.6;">
The Anne Frank Walk was created by Xsite, in co-production with CityFans.<br><br>
Historical research and writing were led by Badass Tours, with deep attention to accuracy, empathy, and tone.<br><br>
We are not affiliated with the Anne Frank House or the Anne Frank Fonds.<br><br>
For all inquiries, please contact:<br>
📧 <strong>info@xsite.com</strong>
Version 1.0 – July 2025<br><br>

<div style="display: flex; justify-content: center; align-items: center; gap: 2rem; margin: 2rem 0;">
<img src="/images/logo-text.png" alt="Xsite Logo" style="width: 120px; height: auto;">
<img src="/images/cityfans.png" alt="CityFans Logo" style="width: 120px; height: auto;">
</div>

<h3 style="font-size: 20px; font-weight: bold; margin-top: 30px; margin-bottom: 15px;">Our Mission</h3>
We believe history isn't just for students or scholars—it belongs to everyone. It should be walked, felt, and remembered.<br><br>
This experience was created to:<br>
• Illuminate the past in the very places it unfolded<br>
• Give voice to stories too often forgotten or unheard<br>
• Connect people to history through human-centered storytelling<br>
• Keep memory alive for future generations<br><br>

<h3 style="font-size: 20px; font-weight: bold; margin-top: 30px; margin-bottom: 15px;">Safety Notice</h3>
Please remember: you're walking through a busy, modern city. Stay alert—especially when wearing earphones—and watch out for pedestrians, vehicles, and bicycles.<br><br>
Use caution when crossing streets, stopping to watch videos, or following navigation directions.<br><br>
Anne Frank Walk, Xsite, CityFans, and their partners are not liable for any injury, damage, or loss. Please use common sense and stay aware of your surroundings as you explore.<br><br>

<h3 style="font-size: 20px; font-weight: bold; margin-top: 30px; margin-bottom: 15px;">Our Use of AI</h3>
We use AI to bring history to life with integrity, not illusion. These four principles guide every creative and technical decision we make:<br><br>

<strong>1. AI is a tool for connection, not deception</strong><br>
We use AI to help people connect with real stories and real lives. The goal is empathy—not spectacle. Visual enhancements are designed to spark curiosity and emotional engagement, not to blur the line between fact and fiction.<br><br>

<strong>2. We interpret history—never invent it</strong><br>
Our animations and reconstructions are grounded in historical sources. When we animate scenes or characters, it's always dramatized from documented context—not imagined out of thin air. We do not fabricate people, events, or documents.<br><br>

<strong>3. We're transparent about our approach</strong><br>
This experience makes broad use of AI tools to visualize and interpret the past. We're clear that all visuals are artistic representations—not literal recordings of reality.<br><br>

<strong>4. We handle the past with care</strong><br>
The people and places depicted in this experience deserve to be remembered with dignity. Every scene, image, and interaction is created with deep respect for the historical record and those it reflects.<br><br>

<h3 style="font-size: 20px; font-weight: bold; margin-top: 30px; margin-bottom: 15px;">Copyright & Attribution</h3>
We claim no copyright over original source images.<br>
Images are drawn from public archives or used under educational fair use.<br>
For a full source list or permissions, reach out to:<br>
📧 <strong>info@xsite.com</strong>
<br><br><br>
© 2025 Xsite XR Ltd. All rights reserved.

</div>`,
                    arIL: "محتوى حول الجولة المتحركة - سيتم إكماله",
                    nlNL: "Over inhoud voor wandeltour - nog aan te vullen"
                }
            }
        },
        terms_of_use: {
            title: {
                heIL: "תנאי שימוש",
                enUS: "Terms of Use",
                arIL: "شروط الاستخدام",
                nlNL: "Gebruiksvoorwaarden"
            },
            content: {
                enUS: `<div style="font-size: 16px; line-height: 1.6;">
<strong>Last updated: July 6, 2025</strong><br><br>

Welcome to our self-guided walking tour experience, brought to you by Xsite XR Ltd. ("we," "our," "us"). Before you begin your tour, please read these Terms and Conditions ("Terms") carefully. By accessing or using our tour experience (the "Service"), you agree to be bound by these Terms.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">1. Purpose of the Experience</h2>

This tour is designed to offer an immersive storytelling journey through historically significant locations. We use modern tools — including AI-generated visuals and narration — to bring the past to life. It is meant to <strong>inspire curiosity and reflection</strong>, not to serve as a definitive or academic source.<br><br>

We make every effort to ensure accuracy and respect for history, but <strong>some elements have been interpreted or reimagined</strong>. This experience should not be considered an official historical, educational, or scholarly resource.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">2. Personal Responsibility & Safety</h2>

You are walking through a <strong>modern, active city</strong>. Please stay alert to your surroundings — including pedestrians, cyclists, vehicles, uneven terrain, and weather conditions. <strong>Use of this tour is entirely at your own risk.</strong><br><br>

We are <strong>not responsible</strong> for:<br>
• Any injuries, accidents, or health issues<br>
• Lost, stolen, or damaged devices or belongings<br>
• Missed appointments, transportation delays, or navigational errors caused by using the Service<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">3. Use of AI & Historical Representation</h2>

The visuals, audio, and scripts you encounter may include <strong>AI-generated content</strong> based on historical texts, testimonies, and photographs. These are intended to <strong>enhance emotional connection</strong>, not to serve as pixel-perfect recreations or factual guarantees.<br><br>

Some scenes may involve <strong>creative interpretation</strong> of historical moments. If you believe any content is inappropriate, inaccurate, or insensitive, please contact us directly.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">4. Device Compatibility & Service Interruptions</h2>

While we strive to support a wide range of devices and operating systems, <strong>we cannot guarantee full functionality</strong> on every platform. GPS accuracy, streaming quality, and responsiveness may vary due to:<br>
• Internet access<br>
• Battery or device limitations<br>
• Signal loss or interference<br>
• App/browser compatibility<br><br>

The Service may also be affected by <strong>external disruptions</strong>, such as:<br>
• Weather events<br>
• Construction or road closures<br>
• Municipal strikes or demonstrations<br><br>

We reserve the right to <strong>pause, alter, or remove content</strong> at any time.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">5. Streaming & Data Usage</h2>

This tour relies on audio, visual, and location-based media, which may require significant <strong>mobile data</strong>. You are solely responsible for any data charges incurred. We recommend using a stable internet connection or checking your mobile plan before beginning the tour.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">6. Age Suitability</h2>

Some content may involve <strong>emotionally difficult topics</strong>, including war, persecution, and personal loss. We make no claim about the suitability of this experience for children. <strong>Parents and guardians should use discretion</strong> before sharing it with minors.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">7. Intellectual Property & Content Restrictions</h2>

All content in this tour — including visuals, voiceovers, music, and design — is protected by copyright, trademark, and intellectual property law. Unless otherwise stated:<br>
• <strong>You may not download, store, share, re-upload, remix, or reproduce any part</strong> of the tour content, including screenshots or audio recordings.<br>
• Content is for <strong>personal, non-commercial use only</strong>.<br>
• Any use beyond this scope requires <strong>prior written permission</strong>.<br><br>

We <strong>do not claim copyright</strong> over historical photographs or source materials used in the experience where those materials are in the public domain or used under license.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">8. Feedback and Suggestions</h2>

If you submit feedback, questions, or suggestions, you grant us the right to use that input (anonymized if published) for product improvement, customer support, or promotional purposes. You waive any claim to compensation or rights over such submissions.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">9. Third Parties & Affiliations</h2>

This experience may reference individuals, locations, or institutions. Unless explicitly stated, we are <strong>not affiliated with or endorsed by any organization</strong> mentioned. Names, likenesses, and references are used solely for the purposes of storytelling.<br><br>

The Service may also include links to third-party content or websites. We do not control or assume responsibility for their content, security, or practices.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">10. Force Majeure</h2>

We are not liable for any failure or delay in performance resulting from events beyond our reasonable control, including natural disasters, war, pandemics, strikes, civil unrest, or governmental actions.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">11. Governing Law</h2>

These Terms are governed by the laws of the <strong>State of Israel</strong>, and any dispute shall be subject to the exclusive jurisdiction of the competent courts in <strong>Tel Aviv</strong>. If any part of these Terms is deemed unenforceable, the rest will remain in effect.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">12. Changes to These Terms</h2>

We may update these Terms at any time to reflect legal, technical, or operational changes. Continued use of the Service after changes are posted constitutes acceptance. We encourage users to check back periodically.<br><br>

<hr style="margin: 20px 0;">

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">13. Content Updates and Modifications</h2>

We reserve the right to add, modify, or remove any part of the Service at any time, including tour content, visuals, narration, features, or functionality, without prior notice. This may be done for technical, creative, legal, or operational reasons. We are not liable for any impact such changes may have on your experience.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Contact Us</h2>

For questions, feedback, or issues related to the tour, email us at <strong>info@xsite.com</strong>

</div>`
            }
        },
        privacy: {
            title: {
                heIL: "מדיניות פרטיות",
                enUS: "Privacy Policy",
                arIL: "سياسة الخصوصية",
                nlNL: "Privacybeleid"
            },
            content: {
                enUS: `<div style="font-size: 16px; line-height: 1.6;">

We, Xsite XR Ltd. ("Xsite", "us", "we", "our"), develop tools of augmented reality, allowing end users to enjoy an innovative tour of various sites with diverse augmented reality features ("Service"). We own and operate the Xsite website available at: www.xsite.com ("Website").<br><br>

Please read the following terms and conditions carefully ("Terms"), because they constitute a binding agreement between you, the user who uses our Website ("you"), and us.<br><br>

By accepting these Terms or by accessing or using the Website, you signify your agreement with these Terms. If you do not agree to these Terms, you may not access or use the Website.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Changes to the Website and Terms</h2>

We may, from time to time, change the Website's structure, layout, design or display, as well as the scope and availability of the information and content therein, without giving any prior notice. Changes of this character by their very nature are likely to result in glitches or cause inconvenience. We will not be held responsible for any outcome of these changes, and failures resulting from them.<br><br>

Xsite also reserves the right to revise, at its sole and absolute discretion, the Terms at any time, including for the purpose of meeting technical, operational and legal requirements. All revisions will be posted on the Website and will be effective immediately upon posting. By use or browse of the Website, you are deemed notified and bound by any changes to these Terms. If you do not accept these revisions to the Terms, then you must immediately stop using the Website.<br><br>

If any provision of these Terms is held by a court of competent jurisdiction to be illegal, invalid, unenforceable, or otherwise contrary to law, the remaining provisions of these Terms will remain in full force and effect.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Use and Limitations</h2>

Do not copy content of the Website, embed it in other websites, display it using framing techniques, create mirroring websites, sell, grant a license to use, rent, lend or distribute the Website's content in any way.<br><br>

Do not modify, create derivative works, reverse engineer, or perform any other action in order to disclose the source code of the Website.<br><br>

Do not link content of the Website separately from the webpage where the content is originally located. When linking to webpages of the Website, no information should be hidden, blocked, modified or deleted from the webpages of the Website.<br><br>

Do not post or transmit to the Website any unlawful, threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic or profane material, or any other material that could give rise to any civil or criminal liability under the law, as well as anything in contravention of these Terms.<br><br>

The Website may not be used for purposes of examination, scanning, scraping, hacking including hacking the Website's security systems or any other computer and communication systems serving it, interfering with the Website's operations, manipulating the Website's activities, systematic access to the Website's systems using automated software tools, such as 'bots' and 'crawlers', and access to the features or functionalities of the Website that are not intended to be accessible or that are not documented.<br><br>

The Website may not be used for any activity that constitutes or encourages the commission of criminal offense or civil wrong or violates applicable laws, including laws in connection with deception, fraud, forgery, privacy protection, identity theft, viruses and other malicious software distribution, right to publicity, slander, harassment and obscene publications.<br><br>

Any attempt to do any of the foregoing is a violation of our rights. If you breach these restrictions, your limited license granted herein will immediately terminate and you may be subject to prosecution and damages.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Intellectual Property</h2>

You agree that all content appearing on the Website including, but not limited to, code, trademarks, service marks, trade names, graphics, images, text, audio clips, button icons, digital downloads, data compilations and computer software (collectively "IP") are the sole property of Xsite or its partners and suppliers and protected by Israel and international copyright laws. All other IP not owned by Xsite that appear on the Website are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by, Xsite.<br><br>

Xsite does not grant, by implication or otherwise, any license or right to use any IP or the content displayed on this Website, without the prior written consent of Xsite. Xsite prohibits the use of the Xsites' logo or other proprietary graphics or trademarks as a link to any Website unless the creation of such a link is approved in advance, and in writing, by Xsite.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Third Party Websites</h2>

The Website may contain links to other websites, information or content provided by third parties. We do not operate or monitor these third-party websites and content. You may find them, or the information and content posted therein, not compatible with your requirements, objectionable, annoying, improper, unlawful or immoral. These websites are subject to their own terms of use and privacy policies.<br><br>

By linking to a certain website, we do not endorse or sponsor its content, nor do we confirm the accuracy, credibility, authenticity, reliability, validity, integrity, or legality of such content.<br><br>

We assume no responsibility for such third-party websites or content, or their availability or for any transactions made between you and such third-party websites. We will not be liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with your use of or reliance on any such content, goods or services available on or through any third-party websites or content.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Information Security</h2>

Xsite and its hosting services providers implement systems, applications and procedures to secure your information, to minimize the risks of theft, damage, loss of information, or unauthorized access or use of information. These measures provide sound industry standard security. However, although we make efforts to protect your information, we cannot guarantee that our systems will be immune from any wrongdoings, malfunctions, unlawful interceptions or access, or other kinds of abuse and misuse.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Termination of Use</h2>

You agree that any violation of these Terms, the unauthorized use of the Website, content materials and IP as well as any fraudulent, abusive or otherwise illegal activity shall be grounds for termination of your right to access, browse and use the Website. Xsite reserves the right to terminate or suspend your access to the Website and its content and use at any time, with or without notice, at Xsite's discretion. Should your access to the Website be terminated, you are prohibited from accessing the Website under a new name unless expressly invited to do so by Xsite.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Disclaimer of Warranty</h2>

All content, materials, and information made available on or through this Website are provided on an "AS IS" basis, without representations, warranties, or conditions of any kind, either express or implied. As such, your use of this Website is at your own risk. Subject to the foregoing, Xsite disclaims all implied warranties including, without limitation, the implied warranties of merchantability and fitness for a particular purpose, and all express warranties except those explicitly made in these Terms.<br><br>

We will make efforts to run the Website efficiently and accessible at all times.<br><br>

However, the Website's operation is dependent upon various factors such as software, hardware and communication networks. By their nature, these factors are not fault free. We do not warrant that the Website will operate in an uninterrupted or error-free manner, or that it will always be available, free from all harmful components, or that at all times it will completely safe, and secured from unauthorized access to our computers, immune from damages, free of malfunctions, bugs or failures, including, but not limited to, hardware failures, software failures and software communication failures, originating either in us or any other service provider. Such incidents will not be considered a breach of these Terms.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Limitation of Liability</h2>

You agree that, except as otherwise provided under applicable laws, neither Xsite nor anyone acting on its behalf shall be liable for any damages whatsoever arising out of or related to the use of, access to, reliance on, or inability to use, this Website or any content in it. This limitation of liability applies to direct, indirect, incidental, consequential, special, punitive, exemplary, statutory, or other damages you or others may suffer, even if Xsite is notified in advance of the potential for any such damages and regardless of the form of action, whether in contract, tort (including negligence), warranty, strict or product liability or otherwise. You shall have no right or authority to have any claims litigated on a class action basis (as a class member, class representative, or otherwise) nor shall your claim be joined with other claims.<br><br>

Certain jurisdictions do not allow limitations on implied warranties or on liability. If you are a resident of such jurisdiction, some or all the above disclaimers, exclusions or limitations may not apply to you, and you might have additional rights.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Data Protection</h2>

1. When using the Website and/or during the course of your engagement with us through the Website, you agree that we will collect, store and use personal data about you, for example, name, phone number, email address and other ways in which we can contact you.<br><br>

2. You are under no legal obligation to deliver the personal data to us and if you do, it is at your own free will and with your consent. You agree, however, that without delivery of the personal data, we may not be able to offer you the full scope of the Website and its functionalities.<br><br>

3. Personal data will be collected, stored and used by us for various purposes, for example, in order to allow you to use the Website; in order to contact you when we believe it is necessary for operating the Website or for the fulfilment of any legal obligation; in order to provide updates related to the Service or support and to reply to any query or complaint; etc.<br><br>

4. We will not transfer personal data to third parties which was collected during your use of the Website and/or during the course of your engagement with us without your consent, except in the following cases: (i) if it is required for the proper operation of the Website and content offered through the Website or by us; We use various third party service providers to provide you with the Website and the Service, such as Intercom; (ii) if we are required to do so by a court order, request of an applicable authority or in accordance with applicable law; (iii) if we receive a threat to take legal action against us based on actions performed by you and/or in the framework of any dispute, claim, suit, demand or legal proceedings, if any, between you and us; (iv) if we will operate through a different entity – including through a merger – it will be entitled to transfer to such entity your personal data and any information about you, if the entity receiving the information takes upon itself the provisions of this Data Protection Section.<br><br>

5. We also collect, use and share aggregated data, for example statistical data using standard analytics tools, such as Google Analytics to learn about how you and other users use the Website, in support of our activities and operations.<br><br>

6. We use different kinds of Cookies in our Website for operating the Website, for example the collection of statistical data pertaining the use of the Website, for verification and for data security. The Website may also use Cookies for advertising purposes.<br>
Cookies are text files that your browser creates based on a command from the Website's systems or from the systems of third parties. Some of the Cookies will expire when you close the browser, while some will be stored on the hard drive in your device. The Cookies may contain various information such as pages you visited, how much time you spent on a website, the source of your arrival to the website, information you sought while browsing a website, etc. Xsite may also use Cookies of other parties, such as Facebook Pixel, Google Tag or Google Analytics and other social media networks which intend to display ads relating to and/or based on your activities on the internet and other websites and services which you have previously visited, etc.<br><br>

Modern browsers allow you to refrain from receiving Cookies. If you do not know how to do so, please check the help file of your browser for the possibility to remove the option to receive Cookies. Neutralizing Cookies may cause certain parts of the Website and its functionalities or any other websites to be inactive.<br><br>

7. Access to personal data related to you: In accordance with the Protection of Privacy Law, 5741 – 1981 ("Law"), you (either yourself, by a proxy or by a lawfully appointed guardian) are entitled to access the personal data related to you that we have. If you find that such personal data is incorrect, incomplete, unclear or not recent, you can turn to us and ask us to correct or delete it, in accordance with the Law and respective regulations. Please submit any related questions to info@xsite.co<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Governing Law and Jurisdiction</h2>

These Terms are governed by Israeli law. Any legal claim will take place with the competent courts of Tel Aviv, Israel. Your use of the Service and Website may also be subject to other local, state, national, or international laws.<br><br>

<h2 style="font-size: 18px; font-weight: bold; margin: 20px 0 10px 0;">Contact Us</h2>

If you have any questions or concerns regarding these Terms, please email us at: <strong>info@xsite.com</strong> We will review your query and make a good-faith effort to respond promptly.<br><br>

<strong>These Terms were last updated on 14 May 2023.</strong>

</div>`
            }
        }
    },
    components: {
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        keypad: {
            error: {
                heIL: 'התחנה המבוקשת לא נמצאת',
                enUS: 'The requested station does not exist ',
                arIL: 'المنطقه المطلوبه غير موجوده',
                nlNL: 'De gevraagde station bestaat niet'
            }
        },
        progressBar: {
            heIL: {
                title: 'התקדמות',
                text: ['הושלמו', 'מתוך']
            },
            enUS: {
                title: 'Tour Progress',
                text: ['Completed', 'of']
            },
            arIL: {
                title: 'تقدم الجولة',
                text: ['تم', 'من']
            },
            nlNL: {
                title: 'Rondleiding voortgang',
                text: ['Voltooid', 'van']
            }
        }
    },
    common: {
        backButton: {
            heIL: 'חזור',
            enUS: 'Back',
            arIL: 'عودة',
            nlNL: 'Terug'
        },
        footer: {
            start: {
                heIL: 'התחל/י סיור',
                enUS: 'Start Tour',
                arIL: 'ابدأ الجولة',
                nlNL: 'Start rondleiding'
            },
            continue: {
                heIL: 'המשך',
                enUS: 'Continue',
                arIL: 'استمر',
                nlNL: 'Doorgaan'
            },
            next: {
                heIL: 'הבא',
                enUS: 'Next',
                arIL: 'التالي',
                nlNL: 'Volgende'
            },
            prev: {
                heIL: 'הקודם',
                enUS: 'Prev',
                arIL: 'السابق',
                nlNL: 'Vorige'
            },
            search: {
                heIL: 'חיפוש',
                enUS: 'Search',
                arIL: 'بحث',
                nlNL: 'Zoeken'
            }
        },
        modals: {
            main: {
                languages: {
                    heIL: 'שפות',
                    enUS: 'Languages',
                    arIL: 'اللغات',
                    nlNL: 'Talen'
                },
                fontSize: {
                    heIL: 'גודל הטקסט',
                    enUS: 'Font Size',
                    arIL: 'حجم الخط',
                    nlNL: 'Lettergrootte'
                }
            },
            fontSize: {
                heIL: ['גופן 1', 'גופן 2', 'גופן 3'],
                enUS: ['Font 1', 'Font 2', 'Font 3'],
                arIL: ['خط 1', 'خط 2', 'خط 3'],
                nlNL: ['Lettergrootte 1', 'Lettergrootte 2', 'Lettergrootte 3']
            }
        }
    }
} as const;

export type TextsMapper = typeof textsMapper;

type NestedValue = string | string[] | readonly string[] | { [key: string]: NestedValue };

export function getText(path: string, langCode: string): string {
  const keys = path.split('.');
  let current: NestedValue = textsMapper as unknown as NestedValue;
  for (const key of keys) {
    if (typeof current === 'object' && current !== null && !Array.isArray(current) && key in current) {
      current = (current as Record<string, NestedValue>)[key];
    } else {
      return '';
    }
  }
  if (typeof current === 'object' && current !== null && !Array.isArray(current) && langCode in current) {
    const val = (current as Record<string, NestedValue>)[langCode];
    if (typeof val === 'string') return val;
    if (Array.isArray(val)) return val.join(', ');
  }
  return '';
}

export function getTextArray(path: string, langCode: string): readonly string[] {
  const keys = path.split('.');
  let current: NestedValue = textsMapper as unknown as NestedValue;
  for (const key of keys) {
    if (typeof current === 'object' && current !== null && !Array.isArray(current) && key in current) {
      current = (current as Record<string, NestedValue>)[key];
    } else {
      return [];
    }
  }
  if (typeof current === 'object' && current !== null && !Array.isArray(current) && langCode in current) {
    const val = (current as Record<string, NestedValue>)[langCode];
    if (Array.isArray(val)) return val;
  }
  return [];
}

export default textsMapper;
